import Beautifier from 'js-beautify';

import { type HTML } from '@editor2/types/pageElements';

const options = {
	unformatted: ['em', 'strong', 'span'],
	indent_inner_html: true,
	indent_char: ' ',
	indent_size: 2,
	max_preserve_newlines: 1,
	preserve_newlines: false
};

const sanitize = (value: string) => {
	return value
		.replace(/<p><br><\/p>/g, '') // remove <p><br></p> in the end

		.replace(/<div><br><\/div>/g, '') // remove <div><br></div>

		.replace(/(\r\n|\r|\n)/g, ' ') // replace all line break characters with a space - beautifier will add needed newlines and squash the spaces

		.replace(/(<(?!ref)[^\/>]+>)\s+/g, '$1') // remove extra space after the opening tag

		.replace(/\s*<\//g, '</'); // remove extra space before the closing tag
};

export const beautifyHtml = (value: string) => {
	const result = sanitize(value);

	return Beautifier.html(result, options);
};

export const parseHTMLTextBody = (element: HTML) => {
	return new DOMParser().parseFromString(element.body, 'text/html').body.textContent;
};
